import React from "react";

import Hint from "./default";
import Icon from "../icon";

export default function HintWithIcon({
  className,
  icon = null,
  attributes = {},
  hasCloser = false,
  onCloserClick,
  children,
}) {
  return (
    <Hint
      className={className}
      attributes={attributes}
      hasCloser={hasCloser}
      onCloserClick={onCloserClick}
    >
      <div className="hint__info-icon">
        <Icon name={icon} />
      </div>
      <div className="hint__message">{children}</div>
    </Hint>
  );
}
